<script lang="ts">
  import { onMount } from "svelte";
  import type { Theme } from "../scripts/WinTypes";
  import SettingsMgr from "../stores/SettingsMgr";

  export let text = undefined;
  export let isLine: boolean = undefined;
  export let colorType: string = "1";
  let lineElem: HTMLElement, textElem: HTMLElement;

  let contElem: HTMLElement;
  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    if (isLine && lineElem) {
      lineElem.style.borderBottom = `1px solid ${c[colorType] || c["1"]}`;
    }
    if (text) {
      textElem.style.color = c[colorType] || c["1"];
    }
    return theme.colors;
  };
  $: _colors = themeWatcher($_theme);

  onMount(() => {
    _colors = themeWatcher($_theme);
  });
</script>

<div class="container" bind:this={contElem}>
  {#if text}
    <div class="text" bind:this={textElem}>
      &nbsp;&gt;&nbsp;{text}
    </div>
  {/if}
  {#if isLine}
    <div class="line" bind:this={lineElem} />
  {/if}
</div>

<style>
  .container {
    position: relative;

    width: 100%;
    /* padding-bottom: 10px; */
  }
  .text {
    /* position: absolute; */
    width: 100%;
    line-height: 2rem;
    /* top: 50%; */
    /* transform: translateY(-50%); */
    word-wrap: break-word;
  }
  .line {
    /* position: absolute; */
    width: 96%;
    margin: 0 auto;
    height: 1rem;
    text-align: center;
    transform: translateY(-50%);
    opacity: 0.2;
  }
</style>
